import React from 'react'
import './NameModal.css'

interface NameModalProps {
  isOpen: boolean
  value: string
  onChange: (v: string) => void
  onCancel: () => void
  onSubmit: (v: string) => void
}

const NameModal: React.FC<NameModalProps> = ({
  isOpen,
  value,
  onChange,
  onCancel,
  onSubmit
}) => {
  if (!isOpen) return null

  return (
    <div className="pm-overlay">
      <div className="pm-container">
        <div className="pm-header">
          <h2 className="pm-title">Building Name</h2>
        </div>

        <div className="pm-body">
          <h4 className="pm-desc">
            Please enter the new building name
          </h4>
          <input
            type="text"
            className="pm-input"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder="e.g. Empire State Building"
          />
        </div>

        <div className="pm-footer">
          <button className="pm-btn pm-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="pm-btn pm-btn--submit"
            onClick={() => onSubmit(value)}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

export default NameModal
